import { Image as MedusaImage } from '@medusajs/medusa'
import Image from 'next/image'
import { useEffect, useState } from 'react'

type ImageGalleryProps = {
  images: MedusaImage[]
}

const ImageGallery = ({ images }: ImageGalleryProps) => {
  const [selectedImage, setSelectedImage] = useState<Maybe<MedusaImage>>(null)

  useEffect(() => {
    setSelectedImage(images[0] ?? null)
  }, [images])

  const handleImageClick = (image: MedusaImage) => {
    setSelectedImage(image)
  }

  return (
    <div className="flex items-start relative">
      <div className="hidden small:flex flex-col gap-y-4 sticky top-20">
        {images.map((image, index) => {
          return (
            <button
              key={image.id}
              className={`h-14 w-12 relative border ${
                selectedImage?.id === image.id
                  ? 'border-blue-500'
                  : 'border-white'
              }`}
              onClick={() => {
                handleImageClick(image)
              }}
            >
              <span className="sr-only">Go to image {index + 1}</span>
              <Image
                src={image.url}
                layout="fill"
                objectFit="contain"
                className="absolute inset-0"
                alt="Thumbnail"
              />
            </button>
          )
        })}
      </div>
      <div className="flex flex-col flex-1 small:mx-16 gap-y-4">
        {selectedImage && (
          <div className="relative aspect-[29/34] w-full">
            <Image
              src={selectedImage.url}
              layout="fill"
              objectFit="contain"
              className="absolute inset-0"
              alt={`Selected image`}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ImageGallery
